// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__MeIb3","title":"Header_title__2qyDH","side":"Header_side__213hB"};